import React from 'react'

const Header = () => {
  return (
      <header>
        <h1>Shopping Lists</h1>
      </header>   
  )
}

export default Header